import React, { useEffect, useState } from 'react'
import { useOneGameModal, usePlayModal } from 'store/one_game/selectors'
import { useCurrentUser } from 'store/users/selectors';
import { Modal as ModalDrop, Input, Tooltip } from 'antd';
import styled from "styled-components"
import { IGameHome7 } from "utils/assets/images";
import {ArrowRightRounded, CheckCircleRounded} from '@mui/icons-material';
import { handleAutologinOneGame, handleCheckGameJoined, handleGameBySessionId } from "store/one_game/thunks";
import Loading from 'components/Loading';
import { useDispatch } from 'react-redux';
import { useCurrentClass } from 'store/classes/selectors';
import { FormHelperText } from '@mui/material'
import { handleUpdateCurrentGameSessionUserSeen } from 'store/game_session/thunks';
import { get, uniq } from 'lodash'
import { collection, doc, getDocs, updateDoc } from 'firebase/firestore';
import { Modal, Button } from "antd";
import { useFirebase } from 'containers/FirebaseContext';
import * as Sentry from "@sentry/react";
import { useBookOrder } from 'store/books/selectors';
import config from 'config';

const Cover = styled.div`
    width: 100%;   
    height: 230px;
    background-image: url(${p => p.src ? `${p.src}` : IGameHome7});
    background-size: 100%; 
    background-position: center; 
    background-repeat: no-repeat; 
`;
const Wrapper = styled.div`
    padding: 0px;
    width: 200px;
    justify-content: center;
    display: flex;
    padding-left: 0px;
    padding-right: 0px;
`;
const Content = styled.div`
      display: flex;
      justify-content:center;
`;
const JoinButton = styled.a`
    &:hover {
       opacity: 0.8;
    }
`;
const InoputBox = styled(Input)`
    width:100%;
    border-radius: 30px;
    border:1px solid #002d74;
`;
const Form = styled.form`
    algin-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    width: 100%;
`;
const ResponsiveModalText = styled.p`
    font-size: 1.1rem;
    color: #222;
    margin-bottom: 0;
    text-align: center;
    @media (max-width: 600px) {
        font-size: 0.95rem;
        padding: 0 8px;
    }
`;

const configServer = import.meta.env.VITE_APP_STAGE?.trim() === 'prod' ? 'prod' : 'dev';

export default function JoinGameNotificationModal() {
    const { playGameModal, closePlayerModal } = usePlayModal();
    const currentUser = useCurrentUser();
    const [viewModal, setViewModal] = useState(false);
    const [joinLoader, setJoinLoader] = useState(false);
    const { openOnegameModal } = useOneGameModal()
    const dispatch = useDispatch();
    const { firestore, signInWithCustomTokenApi } = useFirebase();
    const currentClass = useCurrentClass();
    const [enterGameCode, setEnterGameCode] = useState(false);
    const [gameCode, setGameCode] = useState('');
    const [errorMessage, setErrorMessage] = useState('')
    const [gameStatusEnd, setGameStatusEnd] = useState(false)
    const [gameStatusMessage, setGameStatusMessage] = useState('');
    const item = playGameModal.data.game_data || {};
    const image_url = item && item?.media_urls?.image ? item?.media_urls?.image : IGameHome7
    const has_pin = get(playGameModal.data.game_data,"pin_code")
    const [joinLoader1, setJoinLoader1] = useState(false);
    const studentNameToUpdate = currentUser ? `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim() : '';
    const [showAlreadyJoinedModal, setShowAlreadyJoinedModal] = useState(false);
    const [oneGameUserId, setOneGameUserId] = useState("");
    const bookOrder = useBookOrder()
  const [isTabActive, setIsTabActive] = useState(!document.hidden);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsTabActive(!document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

    useEffect(() => {
        onCheckGameStatus();
        
    }, [playGameModal, currentUser, isTabActive])
    const onCheckGameStatus = async () => {
        setJoinLoader1(true);
        await dispatch(handleGameBySessionId(currentUser.id, playGameModal.data.session_id)).then((listGameData) => {
            const gameSession = get(listGameData, 'game_session', '') ?? {};
            if (gameSession?.status === 'ended') {
                return;
                setGameStatusEnd(true);
                setGameStatusMessage('Game is ended by teacher!!')
            } else {
                if (currentUser && currentUser.id) {
                    if (playGameModal.data.userId !== currentUser.id) {
                        setViewModal(playGameModal.open)
                        setErrorMessage('')
                        setGameCode('')
                        setEnterGameCode(false)
                    }
                }
                setGameStatusEnd(false);
                setGameStatusMessage('')
            }
            setJoinLoader1(false);
        })
            .catch(error => {
                console.error("Error fetching game data:", error);
            });
    }

    useEffect(() => {
        if (playGameModal.open) {
            dispatch(handleUpdateCurrentGameSessionUserSeen(playGameModal.data.session_id, currentUser.id))
        }
    }, [playGameModal])
    const onClose = () => {
        setViewModal(false)
        closePlayerModal()
    }
    const getBooks = () => {
        const books = [];
        (currentClass.books_group || []).forEach((key) => {
            bookOrder.forEach((order) => {
                if (order.key === key) {
                    books.push(...order.order);
                }
            })
        })
       return uniq(books);
    }
    const getClassMetadata = () => {
        return ({
            class_id: currentClass.id,
            class_display_name: currentClass.displayName,
            books: getBooks()
        })
    }
    useEffect(() => {
        if (!playGameModal.open) {
         setShowAlreadyJoinedModal(false);  
        } 
    },[playGameModal.open])
    const logOutFromAnotherDevice = async () => {
        try {
            setJoinLoader(true);
            if (!oneGameUserId) return;
            const collectionRef = collection(firestore, "session_join");
            const snapshot = await getDocs(collectionRef);

            for (const docSnap of snapshot.docs) {
                const data = docSnap.data();
                if (data && data.user_id === oneGameUserId && data.session_id === playGameModal.data.session_id) {
                    await updateDoc(doc(collectionRef, docSnap.id), { studentSessionId: "" });
                }
            }
            setShowAlreadyJoinedModal(false);
            const data = await dispatch(handleAutologinOneGame(currentUser.id, currentClass.id, { action: 'join_game', game_id: playGameModal.data.game_data.game_id, session_id: playGameModal.data.session_id, session_code: playGameModal.data.session_code, class_info: getClassMetadata(), user_name: studentNameToUpdate }));
            if (data && data.key) {
                let uri = `https://1gamestaging.nosotrosonline.com/session_auth`
                if (config.is_local) {
                    uri = `http://${window.location.hostname}:3011/session_auth`
                } else if (configServer === 'prod') {
                    uri = 'https://1game.nosotrosonline.com/session_auth'
                }
                const url = `${uri}?key=${data.key}`
                openOnegameModal(url)
                // await createStudentSession();
            }
            setTimeout(() => onClose(), 2000)
            setErrorMessage('')
            setJoinLoader(false)
        } catch (error) {
            Sentry.captureException(`Log out from another device error: ${error}`);
            setJoinLoader(false);
            return;

        }
    };
    const checkExistingSession = async (userId) => {
        try {
            if (!userId) return;
            // Use firestore from context
            await signInWithCustomTokenApi(currentUser?.id)
            const collectionRef = collection(firestore, "session_join");
            const snapshot = await getDocs(collectionRef);

            let foundSessionId = null;

            const studentSessionId = await sessionStorage.getItem('studentSessionId');
            snapshot.forEach((docSnap) => {
                const data = docSnap.data();
                if (data && data.user_id === userId && data.studentSessionId && data?.studentSessionId !== studentSessionId && data?.session_id === playGameModal.data.session_id) {
                    foundSessionId = data.studentSessionId;
                }
            });
            if (foundSessionId) {
                return true;
            }
            return false;
        } catch (error) {
            Sentry.captureException(`Check Existing login ${error}`);
         }
        finally {
            setJoinLoader(false);
            
        }
    };

    const handleRedirectOnegame = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (joinLoader) return;
    if (has_pin && gameCode !== has_pin) {
        setErrorMessage("Invalid game code");
        return;
    }

    setEnterGameCode(false);
    setGameCode('');
    setJoinLoader(true);

    try {
        const listGameData = await dispatch(handleGameBySessionId(currentUser.id, playGameModal.data.session_id));
        const checkGameJoined = await dispatch(handleCheckGameJoined(currentUser.id, playGameModal.data.session_id));
        const gameSession = get(listGameData, 'game_session', '') ?? {};

        if (gameSession?.status === 'ended') {
            setGameStatusEnd(true);
            setGameStatusMessage('Game is ended by teacher!!');
            return;
        }

        setOneGameUserId(checkGameJoined?.user_id);

        const isMultiple = await checkExistingSession(checkGameJoined?.user_id);
        if (isMultiple) {
            setShowAlreadyJoinedModal(true);
            return;
        }

        const data = await dispatch(handleAutologinOneGame(currentUser.id, currentClass.id, {
            action: 'join_game',
            game_id: playGameModal.data.game_data.game_id,
            session_id: playGameModal.data.session_id,
            session_code: playGameModal.data.session_code,
            class_info: getClassMetadata(),
            user_name: studentNameToUpdate
        }));

        if (data && data.key) {
            let uri = `https://1gamestaging.nosotrosonline.com/session_auth`;
            if (config.is_local) {
                uri = `http://${window.location.hostname}:3011/session_auth`;
            } else if (configServer === 'prod') {
                uri = 'https://1game.nosotrosonline.com/session_auth'
            }
            const url = `${uri}?key=${data.key}`;
            openOnegameModal(url);
        }

        setTimeout(() => onClose(), 2000);
        setErrorMessage('');
    } catch (error) {
        console.error("Join game failed", error);
        setErrorMessage("Something went wrong. Please refresh and try again.");
    } finally {
        setJoinLoader(false);
    }
};


    return (
        <>
            <Modal
                open={showAlreadyJoinedModal && playGameModal.open}
                footer={[
                    <Button key="logout" onClick={logOutFromAnotherDevice} style={{ backgroundColor: "#001940", color: "white" }}>
                        {joinLoader ? <Loading size={16} white />:"Join from this device"}
                        
                    </Button>,
                    <Button key="cancel" onClick={() => setShowAlreadyJoinedModal(false)}>
                        Cancel
                    </Button>
                ]}
                closable={false}
            >
                <ResponsiveModalText>
                    You are already participating in this game from another tab or device.<br />
                    Please choose an option below to continue.
                </ResponsiveModalText>
            </Modal>
            <ModalDrop
                open={viewModal}
                onCancel={onClose}
                className={`join-game-modal`}
                style={{ width:"max-content !important" }}
                maskClosable={false}
            >
                <Content>
                    <Wrapper className='aiGmMdl'>
                        <div className='myUnitsGm' style={{ overflow: "hidden", border: "1px solid", minWidth: 200 }}>
                            <div className='myUnitsBnr frameStyle'>
                                {/* <Cover src={image_url} /> */}
                                <img
                                    src={image_url}
                                    alt=""
                                    className='imageStyle'
                                />
                            </div>
                            <div className='myUnitsTxt'>
                                <div className='myUnitsInfo'>
                                    {/* <label>{item.display_name || 'Untitled'}</label> */}
                                    {item?.display_name && item.display_name.length > 20 ? (
                                        <Tooltip title={item.display_name}>
                                            <label className='text-dark'>{item?.display_name.slice(0, 20) + '...'}</label>
                                        </Tooltip>
                                    ) : (
                                        <label className='text-dark'>{item?.display_name || 'Untitled'}</label>
                                    )}
                                    {/* <p>{item?.category?.category_name || "--"}</p> */}
                                    {/* <span>Pg. {item?.sub_category?.category_name || item?.sub_category?.reference_id || '--'}</span> */}
                                </div>
                                {!!errorMessage ? <FormHelperText error>{errorMessage}</FormHelperText> : null}
                                <div className='myUnitsBtns'>
                                    {enterGameCode ? <InoputBox disabled={joinLoader} placeholder="Enter code" value={gameCode} onChange={e => {
                                        setGameCode(e.target.value.trim())
                                        setErrorMessage('')
                                    }}
                                        onKeyDown={e => {
                                            if (e.key === "Enter" && !joinLoader) {
                                                handleRedirectOnegame(e);
                                            }
                                        }}
                                    /> : null}

                                    { joinLoader1 ? <Loading size={16} style={{ color: '#001940' }} /> :


                                        (gameStatusEnd ? (
                                            <p>{gameStatusMessage}</p>
                                        ) : (
                                            <JoinButton onClick={(e) => {
                                                if(!has_pin||enterGameCode){
                                                    handleRedirectOnegame(e)
                                                }else{
                                                    setEnterGameCode(true)
                                                }
                                            }}
                                                className='BtnsStart'>
                                                <ArrowRightRounded />{joinLoader ? <Loading size={16} white /> : "Join"}
                                            </JoinButton>
                                        ))
                                    }
                                </div>
                                <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                            </div>
                        </div>
                    </Wrapper>
                </Content>
            </ModalDrop>

        </>
    )
}
